import { tv, type VariantProps } from "tailwind-variants";

export const colorItemVariant = tv({
  slots: {
    base: ["flex", "flex-col", "gap-6.5", "p-5", "rounded-lg", "border"],
    title: [],
    content: ["flex", "items-start", "justify-between", "gap-2", "w-full"],
    contentItem: ["flex", "flex-col", "grow", "items-start"],
    legend: ["uppercase"],
    value: ["uppercase"],
    copyButton: [
      "flex",
      "items-center",
      "justify-start",
      "gap-2",
      "cursor-pointer",
      "group",
    ],
    copyIcon: [
      "w-4",
      "h-4",
      "opacity-0",
      "transition-opacity",
      "duration-300",
      "ease-in-out",
      "group-hover:opacity-100",
    ],
  },
  variants: {
    contrastBorder: {
      true: {
        base: ["border-border-neutral-default", "dark:border-neutral-dark-alpha-4"],
      },
      false: {
        base: "border-transparent",
      },
    },
  },
  defaultVariants: {
    contrastBorder: false,
  },
});

export type ColorItemVariantProps = VariantProps<typeof colorItemVariant>;
export type ColorItemReturnVariantProps = ReturnType<typeof colorItemVariant>;
